<template>
    <fieldset class="base-fieldset">
        <div v-if="hasSlot('header')" class="base-fieldset__header">
            <slot name="header"></slot>
        </div>
        <div :class="`base-fieldset__list base-fieldset__list--col-${col}`">
            <slot></slot>
        </div>
    </fieldset>
</template>

<script>
import hasSlots from "@/mixins/hasSlots";

export default {
    name: "BaseFieldset",
    mixins: [hasSlots],
    props: {
        col: {
            default: 1
        }
    }
}
</script>

<style lang="scss">

@import "@sass/vue-component";

.base-fieldset {
    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;

        > label, > legend {
            color: $primary;
            @include font-size(1.5rem);
            margin-bottom: 0;
        }
    }


    &__list {
        //TODO change to grid gap?
        > *:not(:last-child) {
            margin-bottom: 1rem;
        }
    }

    &__list--col-2 {
        @include two_column_input_grid;

        > *:not(:last-child) {
            margin-bottom: 0;
        }
    }
}

</style>
